"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Paper_1 = require("./Paper");
Object.defineProperty(exports, "Paper", { enumerable: true, get: function () { return Paper_1.Paper; } });
//# sourceMappingURL=index.js.map